module.exports = __webpack_public_path__ + "img/tos_w.dce0c1f4.svg";